<template>
  <div class="home-content">
    <div class="head-select">
      <el-input v-model="searchval" placeholder="请输入手机号、姓名等" class="search-input"></el-input>
      <el-button type="primary" class="search-button" @click="search">
        <img src="@/assets/icon/search.png" alt="" class="button-icon" />
        查询
      </el-button>
      <!-- <el-button type="primary" class="search-button" @click="allint">批量</el-button> -->
      <el-button type="primary" class="search-button" @click="allint2">批量导入</el-button>
      <el-button type="primary" class="add-button" @click="add">
        新增
      </el-button>
      <el-button type="danger" class="del-button" @click="delUserMulti">
        删除
      </el-button>
    </div>
    <div class="machine-content">
      <div class="list-con">
        <el-table ref="filterTable" :data="tabelData" tooltip-effect="dark" style="width: 100%"
          @selection-change="handleSelectionChange" v-if="tabelData.length">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :prop="item.key" :label="item.label" v-for="item in dataSource" :key="item.key" >
            <template slot-scope="scope">
              <div class="text" v-if="!slotmap.includes(item.key)">
                {{ scope.row[item.key] ? scope.row[item.key] : "--" }}
              </div>
              <div class="text" v-else-if="item.key == 'group' || item.key == 'product'">
                {{ scope.row[item.key] ? scope.row[item.key]["name"] : '--' }}
              </div>
              <div class="text" v-else-if="item.key == 'team_id'">
                {{ getGroupName(scope.row[item.key]) }}
              </div>
              <div class="text" v-else-if="item.key == 'avatar'">
                {{ scope.row[item.key] == defaultAvatar ? '无' : '有' }}
              </div>
              <div v-else-if="item.key == 'menu'" class="tab-menu">
                <div class="edit" @click="edit(scope.row)">编辑</div>
                <div class="line"></div>
                <div class="delbtn" @click="delUserSingle(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" :total="numdata"
        style="margin-top: 30px; float: right; margin-right: 60px" :current-page="current_page" :page-size="page_size"
        @current-change="handleCurrentChange" @prev-click="handleCurrentChange_prev"
        @next-click="handleCurrentChange_next">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addvisible" :modal-append-to-body="false" custom-class="edit-dialog" @close="dialogclose"
      :destroy-on-close="true" :close-on-click-modal="false" top="7vh" width="720px">
      <div slot="title">{{ formData.id > 0 ? "编辑" : "新增" }}</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">用户头像</div>
          <el-upload class="upload-demo" :action="headurl + loadurl" list-type="picture-card"
            :on-preview="handlePreview" multiple :show-file-list="false" :on-success="upsuccess">
            <div class="img_add_box">
              <div class="img_add_btn">
                <el-image class="img_add_icon" :src="imgAdd" fit="contain" />
              </div>
            </div>
          </el-upload>
          <div class="avater-img">
            <img :src="imghead + avater" />
          </div>
        </div>
        <div class="edit-item">
          <div class="text">用户名</div>
          <el-input :disabled="isEdit" class="edit-input" v-model="formData.username" placeholder="请输入用户名"></el-input>
        </div>
        <div class="edit-item">
          <div class="text">密码</div>
          <el-input type="password" class="edit-input" v-model="formData.password" placeholder="请输入密码"></el-input>
        </div>
        <div class="edit-item">
          <div class="text">确认密码</div>
          <el-input type="password" class="edit-input" v-model="formData.confirmPassword"
            placeholder="请再次输入密码"></el-input>
        </div>
        <div class="edit-item">
          <div class="text">姓名</div>
          <el-input class="edit-input" v-model="formData.nickname" placeholder="请输入姓名"></el-input>
        </div>
        <div class="edit-item">
          <div class="text">类型</div>
          <el-select v-model="formData.group_id" placeholder="请选择员工类型" class="edit-input">
            <el-option v-for="item in grouplist" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="edit-item">
          <div class="text">所属生产组</div>
          <el-select v-model="formData.team_id" placeholder="请选择员工类型" class="edit-input">
            <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose">取消</el-button>
          <el-button type="primary" size="small" @click="addUser">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- <el-dialog
      :visible.sync="addvisible"
      :modal-append-to-body="true"
      custom-class="edit-dialog"
      @close="dialogclose"
      :destroy-on-close="true" 
      :close-on-click-modal ="false"
      width="720px"
    >
      <div slot="title">新增</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">用户名</div>
          <el-input
            class="edit-input"
            v-model="formData.username"
            placeholder="请输入手机号"
          ></el-input>
        </div>
        <div class="edit-item">
          <div class="text">密码</div>
          <el-input type="password"
            class="edit-input"
            v-model="formData.password"
            placeholder="请输入密码"
          ></el-input>
        </div>
        <div class="edit-item">
          <div class="text">确认密码</div>
          <el-input type="password"
            class="edit-input"
            v-model="formData.confirmPassword"
            placeholder="请再次输入密码"
          ></el-input>
        </div>        
        <div class="edit-item">
          <div class="text">姓名</div>
          <el-input
            class="edit-input"
            v-model="formData.nickname"
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div class="edit-item">
          <div class="text">类型</div>
          <el-input
            class="edit-input"
            v-model="formData.group_id"
            placeholder="请输入类型"
          ></el-input>
        </div>        
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="addUser"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>   -->
  </div>
</template>

<script>
import imgAdd from '/src/assets/icon/img_add.png'
import { delUsers, editNewUsers, getUserLists, addNewUsers, getGrouupLists } from "../../api/index";
import datajson from './data.json'
const XLSX = require('xlsx')
export default {
  data() {
    return {
      datajson,
      vindex: 0,
      imgAdd,
      activeName: "first",
      timer1: "",
      searchval: "",
      dataSource: [
        { label: "ID", key: "id" },
        { label: "头像", key: "avatar" },
        { label: "用户名(手机号)", key: "mobile" },
        { label: "姓名", key: "nickname" },
        { label: "员工组别", key: "team_id" },
        { label: "类型", key: "group" },
        { label: "操作", key: "menu" },
      ],
      tabelData: [],
      slotmap: ["menu", "product", "group", 'avatar', 'team_id'],
      numdata: 0,
      current_page: 1,
      page_size: 10,
      addvisible: false,
      formData: {
        id: 0,
        username: "",
        //mobile:"",
        password: "",
        confirmPassword: "",
        nickname: "",
        group_id: 1,
      },
      delList: [],//删除列表
      isEdit: false,
      headurl: "https://fmadmin.sewme.cn/index.php",
      avater: '',
      loadurl: '/admin/ajax/upload',
      imghead: 'https://fmadmin.sewme.cn',
      defaultAvatar: '/static/images/avatar.png',
      grouplist: [
        { name: '员工', id: 1 },
        { name: '主管', id: 2 },
      ],
      quicklist: [],
      teamList: []
    };
  },
  methods: {
    delUserMulti() {
      if (this.delList.length == 0) {
        this.$message.warning("请选择要删除的用户!");
        return;
      }
      this.$confirm(
        '确认删除选择的用户吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms = {
          ids: this.delList,
        }
        delUsers(forms).then(res => {
          if (res.code == 1) {
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.delList = [];
            this.getData();
          } else {
            this.$message.warning(res.msg);
            //this.$message.warning("删除失败!");
          }
        });
      }).catch((err) => {
        Message.warning('取消操作');
      })
    },
    delUserSingle(row) {
      this.$confirm(
        '确认删除该用户吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms = {
          ids: [row.id],
        }
        delUsers(forms).then(res => {
          if (res.code == 1) {
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.getData();
          } else {
            this.$message.warning(res.msg);
            //this.$message.warning("删除失败!");
          }
        });
      }).catch((err) => {
        Message.warning('取消操作');
      })
    },
    dialogclose() {
      this.addvisible = false;
    },
    //添加修改用户
    addUser() {
      if (!this.formData.username) {
        this.$message.warning("用户名不能为空!");
        return;
      }
      // if(!this.formData.mobile){
      //   this.$message.warning("手机号不能为空!");
      //   return;
      // } 
      if (this.isEdit == false) {
        if (this.formData.username.length != 11) {
          this.$message.warning("请输入11位手机号!");
          return;
        }
      }
      if (this.formData.id == 0) {
        if (!this.formData.password) {
          this.$message.warning("密码不能为空!");
          return;
        }
      }
      if (this.formData.password) {
        if (this.formData.password.length < 6) {
          this.$message.warning("密码不能小于6位!");
          return;
        }
        if (!this.formData.confirmPassword) {
          this.$message.warning("请再次输入密码!");
          return;
        }
        if (this.formData.password != this.formData.confirmPassword) {
          this.$message.warning("两次输入的密码不相同!");
          return;
        }
      }
      if (!this.formData.nickname) {
        this.$message.warning("姓名不能为空!");
        return;
      }
      if (this.formData.id == 0) {
        addNewUsers(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("添加成功!");
              this.getData();
            } else {
              this.$message.warning(res.msg);
              //this.$message.error("添加用户失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        editNewUsers(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("修改成功!");
              this.getData();
            } else {
              this.$message.warning(res.msg);
              //this.$message.error("编辑用户失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getData();
    },
    getData() {
      let params = {
        limit: this.page_size,
        page: this.current_page,
        quickSearch: this.searchval,
      };
      getUserLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.tabelData = res.data.list;
            console.log(res);
            this.numdata = res.data.total;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.current_page = 1;
      this.getData();
    },
    handleClick(active) { },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delList = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        this.delList.push(this.multipleSelection[i].id);
      }

    },
    add() {
      this.addvisible = true;
      this.formData = {
        id: 0,
        username: "",
        password: "",
        confirmPassword: "",
        nickname: "",
        group_id: 1,
      };
      this.isEdit = false;
    },
    del() { },
    edit(row) {
      this.formData = {
        id: row.id,
        username: row.username,
        password: "",
        confirmPassword: "",
        nickname: row.nickname,
        group_id: row.group_id,
        avatar: row.avatar,
        team_id: row.team_id
      }
      this.avater = this.formData.avatar
      console.log('___avater', this.avater)
      this.isEdit = true;
      this.addvisible = true;
      console.log("rows====" + JSON.stringify(row));

    },
    itemdel() { },
    handlePreview(file) {
      console.log(file);
    },
    upsuccess(e) {
      this.avater = e.data.file.url
      this.formData.avatar = this.avater
    },
    imgupload(file) {
      console.log('___imgupload', file)
    },
    allint() {
      if (this.vindex < this.jsondata.length) {
        let vdata = this.jsondata[this.vindex]
        if (vdata.mobile && vdata.name) {
          let formData = {
            id: 0,
            username: vdata.mobile,
            password: "123456",
            confirmPassword: "123456",
            nickname: vdata.name,
            group_id: 1,
            team_id: vdata.team_id,
            avatar: `/storage/Sewing02/${vdata.mobile}.jpg`
          }
          addNewUsers(formData).then((res) => {
            if (res.code == 1) {
              this.$message.success(`用户添加进度:${this.vindex+1}/${this.jsondata.length}`);
              this.addvisible = false;
            } else {
              this.$message.warning(`第${this.vindex+1}位添加失败：${res.msg}`);
            }
            setTimeout(() => {
              this.vindex += 1
              this.allint()
            }, 500);
          })
        } else {
          this.vindex += 1
          this.allint()
        }
      } else {
        this.vindex = 0
        this.$message.warning(`所有员工已添加成功，刷新页面后可获取最新员工列表`);
        return
      }

    },
    allint2() {
      // 检查 XLSX 是否加载成功
      if (!XLSX) {
        this.$message.error('XLSX 库加载失败');
        return;
      }
      
      // 创建文件输入元素
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx,.xls';
      
      // 监听文件选择
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        // 检查文件类型
        if (!file.name.match(/\.(xlsx|xls)$/i)) {
          this.$message.warning('请选择 Excel 文件');
          return;
        }
        
        // 创建 FileReader
        const reader = new FileReader();
        
        // 读取文件完成时的回调
        reader.onload = (e) => {
          try {
            // 检查 e.target.result 是否存在
            if (!e.target.result) {
              throw new Error('文件读取结果为空');
            }
            
            // 使用 xlsx 库解析 excel 文件
            const workbook = XLSX.read(e.target.result, { type: 'binary' });
            
            // 获取第一个工作表
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // 转换为 JSON 格式
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            
            console.log('Excel 数据解析成功:', jsonData);
            this.$message.success('文件读取成功，共解析 ' + jsonData.length + ' 条数据');
            
            // 这里可以根据需要处理解析的数据
            // 例如：批量添加用户
            this.processExcelData(jsonData);
          } catch (error) {
            console.error('文件读取失败:', error);
            this.$message.error('文件读取失败: ' + error.message);
          }
        };
        
        // 读取文件为二进制字符串
        reader.readAsBinaryString(file);
      };
      
      // 触发文件选择对话框
      input.click();
    },
    processExcelData(data) {
      // 处理解析后的 Excel 数据
      // 这里可以根据实际 Excel 表格的结构进行调整
      if (!data.length) return
      this.jsondata = []
      data.forEach((item, index) => {
        // 假设 Excel 表格包含以下列：mobile, name, team_id
        let formData = {
          mobile: item.mobile ||'',
          name: item.name || '',
          team_id: item.team_id || '',
        };
        this.jsondata.push(formData)
        console.log('准备添加用户:', formData);
      });
      this.allint()
    },
    intavatar() {
      let params = {
        limit: 99999,
        page: 1
      };
      getUserLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.quicklist = res.data.list;
            this.setavatar(this.quicklist, 0)
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setavatar(list, index) {
      if (list.length > index) {
        if (list[index].avatar.includes('Sewing01')) {
          let nparams = {
            ...list[index],
            avatar: `/storage/Sewing01/${list[index].mobile}.JPG`
          }
          editNewUsers(nparams).then((res) => {
            if (res.code == 1) {
              setTimeout(() => {
                this.setavatar(list, index + 1)
              }, 500);
            }
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
        } else {
          setTimeout(() => {
            this.setavatar(list, index + 1)
          }, 500);
        }
      }
    },
    getTeamList() {
      let params = {
        limit: 1000,
        page: 1,
      };
      getGrouupLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.teamList = res.data.list;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGroupName(id) {
      if (!this.teamList.length) {
        return '--'
      }
      let vitem = this.teamList.find(item => item.id == id)
      if (vitem && vitem.name) {
        return vitem.name
      } else {
        return '--'
      }
    }
  },
  mounted() {
    this.getData();
    this.getTeamList()
    // this.headurl = localStorage.getItem('baseurl')
  },
};
</script>

<style lang="scss" scoped>
.home-content {
  height: calc(100% - 64px);

  .head-select {
    padding: 24px 0 24px 42px;
    display: flex;
    align-items: center;

    .el-date-editor {
      margin-left: 16px;
      width: 185px;
    }
  }

  .search-input {
    width: 245px;
  }

  .search-select {
    width: 185px;
    margin-left: 16px;
  }

  .search-button {
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fefeff;
    line-height: 14px;
    padding: 10px 20px;

    .button-icon {
      margin-right: 10px;
      width: 15.5px;
      height: 15.5px;
    }
  }

  .add-button {
    margin-left: auto;
  }

  .del-button {
    margin-right: 125px;
  }

  .machine-content {
    padding: 0 28px;
    height: calc(100% - 88px);
    background: #fff;
  }

  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }

  .tab-menu {
    display: flex;
    align-items: center;
    column-gap: 12px;
  }

  .edit {
    cursor: pointer;
    color: #507af9;
  }

  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}

.edit-dialog {
  .edit-input {
    margin: 10px 0;
  }
}

.upload-demo {
  display: inline-flex;
  margin: 16px 0;
}

.img_add_box {
  height: 100%;

  .img_add_icon {
    width: 32px;
    height: 32px;
  }
}

.avater-img {
  display: inline-block;
  width: 146px;
  height: 146px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  margin-left: 16px;
  cursor: pointer;

  >img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
<style lang="scss">
.list-con {
  padding-top: 30px;

  .el-table__header-wrapper {
    th {
      background: #fafafa;
      color: #0c0c0c;
    }
  }
}
</style>